import { render, staticRenderFns } from "./OnboardingSidePanel.vue?vue&type=template&id=51f90177&scoped=true"
import script from "./OnboardingSidePanel.vue?vue&type=script&lang=js"
export * from "./OnboardingSidePanel.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSidePanel.vue?vue&type=style&index=0&id=51f90177&prod&lang=scss&scoped=true"
import style1 from "./OnboardingSidePanel.vue?vue&type=style&index=1&id=51f90177&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f90177",
  null
  
)

export default component.exports